import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { SelectItem } from 'primeng/api';
import { BaseComponent } from '../../../../core/abstracts/baseComponent';
import { QueuesService } from '../../../../core/services/queues.service';
import { BenefitsService } from '../../../../core/services/benefits.service';
import { State } from '../../../../core/store';
import { loadViewableCampuses } from '../../../../core/store/employee/employee.action';
import { loadProfile } from '../../../../core/store/profile/profile.actions';
import { InsuranceChangeModel } from '../../../../models/insuranceChangeModel';
import { downloadFile } from '../../../../helpers/utils';

@Component({
  selector: 'app-insurance-changes',
  templateUrl: './insurance-changes.component.html',
  standalone: false
})
export class InsuranceChangesComponent extends BaseComponent implements OnInit {
  items: InsuranceChangeModel[] = [];
  campuses: SelectItem[] = [];
  campusId = 0;
  employee = '';
  first = 0;
  total = 0;
  loading = false;
  saving = false;
  selected: InsuranceChangeModel | null = null;
  note = '';
  error = '';
  message = '';

  constructor(private queues: QueuesService, private benefits: BenefitsService, private store: Store<State>) { super(); }

  ngOnInit(): void {
    this.subs.push(this.store.select(s => s.employeeState.campuses).subscribe(x => this.campuses = x || []));
    this.store.dispatch(loadViewableCampuses());
    this.load();
  }

  load(first = 0): void {
    if (this.saving || this.loading) return;
    this.first = first;
    this.loading = true;
    this.selected = null;
    this.error = '';
    this.subs.push(this.queues.getInsuranceChanges(first, this.campusId, this.employee).subscribe({
      next: result => { this.items = result.result; this.total = result.totalRecords; this.loading = false; },
      error: error => { this.loading = false; this.error = typeof error.error === 'string' ? error.error : error.message; }
    }));
  }

  review(item: InsuranceChangeModel): void {
    if (this.saving) return;
    this.selected = item;
    this.note = '';
    this.error = '';
    this.message = '';
  }

  downloadDocuments(item: InsuranceChangeModel): void {
    this.subs.push(this.benefits.downloadEnrollmentSetSignedForms(item.id).subscribe({
      next: data => downloadFile(data, `InsuranceChange-${item.id}.zip`),
      error: async error => {
        this.error = error.error instanceof ArrayBuffer ? new TextDecoder().decode(error.error) : error.message;
      }
    }));
  }

  decide(approve: boolean): void {
    if (this.saving || !this.selected) return;
    const submitted = this.selected;
    const note = this.note.trim();
    if (!approve && !note) { this.error = 'Enter an explanation for the employee before rejecting.'; return; }
    this.saving = true;
    this.error = '';
    this.subs.push(this.queues.decideInsuranceChange(submitted.id, approve, note, submitted.requestedDate).subscribe({
      next: () => {
        this.saving = false;
        this.message = `${submitted.employee}: request ${approve ? 'approved' : 'rejected'}.`;
        this.store.dispatch(loadProfile());
        this.load();
      },
      error: error => { this.saving = false; this.error = typeof error.error === 'string' ? error.error : error.message; }
    }));
  }
}
